import ApiKeyTag from "./ApiKeyTag";
import RemoveIntegrationButton from "./RemoveIntegrationButton";
import SettingsContainer from "./SettingsContainer";

import type { JSX } from "react";

type EmailOutreachSettingsProps = (
  | ({ type: "instantly" } & (
      | { workspaceName: string }
      | { errorMessage: string }
    ))
  | { type: "smartlead"; apiKey: string }
) & {
  onRemove: () => void;
};

export default function EmailOutreachSettings(
  props: EmailOutreachSettingsProps,
) {
  const { type, onRemove } = props;

  let content: JSX.Element;

  if ("errorMessage" in props) {
    const { errorMessage } = props;
    content = (
      <p className="text-red-500 text-sm">
        There was an error loading the integration settings: {errorMessage}.
        Please remove the integration and add it again. If the problem persists
        contact support
      </p>
    );
  } else {
    content =
      type === "instantly" ? (
        <div className="flex flex-col items-start gap-y-1.5">
          <span className="text-button-xs">Instantly workspace</span>

          <h4 className="p-4 border-black-200 border w-full rounded-3xl text-md-bold">
            {props.workspaceName}
          </h4>

          <p className="text-xs text-black-500">
            To change your selected workspace, you must disconnect this one.
          </p>
        </div>
      ) : (
        <div className="flex items-center gap-x-1.5 justify-between">
          <h4 className="text-button-xs">Smartlead API key</h4>
          <ApiKeyTag token={props.apiKey} />
        </div>
      );
  }

  return (
    <SettingsContainer integrationKey={type}>
      <div className="flex flex-col gap-y-6 lg:p-4">
        {content}
        <RemoveIntegrationButton integrationKey={type} onRemove={onRemove} />
      </div>
    </SettingsContainer>
  );
}
